import { ResponseError } from '../../errors/responseError';
import { fetchGetTips, TGetTipsResponse } from '../../repositories/text-search/v2/get-tips';
import { IApplicationContext } from '../../types/applicationContext';
import { ITips } from '../../types/tips';

const DEGRADATION_TELEMETRY_KEY = 'degradation.getTips';

export async function fetchTips(context: IApplicationContext, text: string): Promise<ITips | null> {
  const { httpApi, logger, telemetry } = context;

  try {
    const { statusCode, response }: TGetTipsResponse = await fetchGetTips({
      httpApi,
      parameters: {
        text,
      },
    });
    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);

      const responseError = new ResponseError({
        domain: 'services.fetchSuggestionsByText',
        message: response.message || '',
        details: {
          // oxlint-disable-next-line typescript/no-explicit-any
          error: response.errors as any,
        },
      });

      logger.warning(responseError);
      throw responseError;
    }

    return response;
  } catch (ex) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(ex);

    return null;
  }
}
